import { Blockquote } from '@radix-ui/themes';
import { ReactNode, useState } from 'react';

export const Details = (props: {
  children: ReactNode;
  summary?: ReactNode;
}) => {
  const [open, setOpen] = useState(false);

  return (
    <Blockquote
      className="clickable"
      truncate={!open}
      onClick={() => setOpen((prev) => !prev)}
    >
      {props.children}
    </Blockquote>
  );
};
